import { render, staticRenderFns } from "./QRCodeIcon.vue?vue&type=template&id=a3b4c84a&"
import script from "./QRCodeIcon.vue?vue&type=script&lang=js&"
export * from "./QRCodeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports